import Icon from "components/Common/Icon";
import { getWowStatic } from "hooks/wow/getStaticData";
import { getEnchantName, getEnchantQuality, getEnchantQualityIconSrc, getEnchantImgLinkSrc, trimQuality } from "lib/enchant-ids";
import React from "react";
import WowTooltip from "../Tooltips/WowTooltip";

const ArmorItemCombo = ({ data, encounterType }) => {
  let firstItemId, secondItemId, firstItemEnchant, secondItemEnchant, popularity, count;

  firstItemId = data?.first_item_id;
  secondItemId = data?.second_item_id;
  firstItemEnchant = data?.first_item_enchant_name;
  secondItemEnchant = data?.second_item_enchant_name;
  popularity = data?.popularity;
  count = data?.count;

  const firstItemStaticData = getWowStatic("item", firstItemId);
  const secondItemStaticData = getWowStatic("item", secondItemId);

  return (
    <div className="armor-item-reversed combo-armor-item">
      <div className="combo-items">
        <div className="armor-item-container">
          <WowTooltip type="item" id={firstItemId}>
            <Icon staticDataImg={firstItemStaticData?.img} color="rgb(163, 53, 238)" classType="bis-item-icon" />
          </WowTooltip>
          <div className="item-info-right">
            <div className="item-name" style={{ color: "rgb(163, 53, 238)" }}>
              {firstItemStaticData?.name}
            </div>
            <div className="enchant-info">
              {firstItemEnchant ? (
                <>
                  <Icon iconSize="18px" staticDataImg={getEnchantImgLinkSrc(firstItemEnchant)} />
                  <div className="enchant-text">{trimQuality(getEnchantName(firstItemEnchant?.split(" (")[0]))}</div>
                  <img
                    style={
                      getEnchantQuality(firstItemEnchant) == 2
                        ? { width: "16px", height: "8px", marginLeft: "4px" }
                        : { width: "16px", height: "12px", marginLeft: "4px" }
                    }
                    src={getEnchantQualityIconSrc(firstItemEnchant)}
                  ></img>
                </>
              ) : null}
            </div>
          </div>
        </div>
        <div className="horizontal-line" />
        <div className="armor-item-container">
          <WowTooltip type="item" id={secondItemId}>
            <Icon staticDataImg={secondItemStaticData?.img} color="rgb(163, 53, 238)" classType="bis-item-icon" />
          </WowTooltip>
          <div className="item-info-right">
            <div className="item-name" style={{ color: "rgb(163, 53, 238)" }}>
              {secondItemStaticData?.name}
            </div>
            <div className="enchant-info">
              {secondItemEnchant ? (
                <>
                  <Icon iconSize="18px" staticDataImg={getEnchantImgLinkSrc(secondItemEnchant)} />
                  <div className="enchant-text">{trimQuality(getEnchantName(secondItemEnchant?.split(" (")[0]))}</div>
                  <img
                    style={
                      getEnchantQuality(secondItemEnchant) == 2
                        ? { width: "16px", height: "8px", marginLeft: "4px" }
                        : { width: "16px", height: "12px", marginLeft: "4px" }
                    }
                    src={getEnchantQualityIconSrc(secondItemEnchant)}
                  ></img>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className="popularity-container">
        <div className="popularity-value">{parseFloat(popularity).toFixed(1) + "%"}</div>
        <div className="popularity-label">
          ({count?.toLocaleString("en-US")} {encounterType.toLowerCase() === "pvp" ? "players" : "parses"})
        </div>
      </div>
    </div>
  );
};

export default ArmorItemCombo;
